(() => {
  const prefersReduced =
    window.matchMedia &&
    window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  const nodes = Array.from(document.querySelectorAll('[data-bstudio-countup]'));
  if (!nodes.length) return;

  const parseTarget = (el) => {
    const raw = (el.getAttribute('data-target') || '').trim();
    const normalized = raw.replace(/\s/g, '').replace(',', '.');
    const n = Number.parseFloat(normalized);
    return Number.isFinite(n) ? { value: n, raw } : { value: 0, raw };
  };

  const formatValue = (value, decimals) => {
    if (decimals <= 0) return String(Math.round(value));
    return value.toFixed(decimals);
  };

  const animate = (el) => {
    if (el.dataset.animated === 'true') return;
    el.dataset.animated = 'true';

    const { value: targetValue, raw } = parseTarget(el);
    const decimals = (raw.includes('.') || raw.includes(',')) ? (raw.split(/[.,]/)[1] || '').length : 0;
    const duration = Math.max(600, Math.min(1600, Number(el.getAttribute('data-duration')) || 1100));

    if (prefersReduced || duration === 0) {
      el.textContent = formatValue(targetValue, decimals);
      return;
    }

    const start = performance.now();
    const from = 0;

    const tick = (now) => {
      const t = Math.min(1, (now - start) / duration);
      // easeOutCubic
      const eased = 1 - Math.pow(1 - t, 3);
      const current = from + (targetValue - from) * eased;
      el.textContent = formatValue(current, decimals);
      if (t < 1) requestAnimationFrame(tick);
    };

    requestAnimationFrame(tick);
  };

  const runIfNeeded = (el) => {
    const rect = el.getBoundingClientRect();
    const vh = window.innerHeight || document.documentElement.clientHeight;
    if (rect.top <= vh * 0.85) animate(el);
  };

  if ('IntersectionObserver' in window) {
    const io = new IntersectionObserver(
      (entries) => {
        for (const e of entries) {
          if (e.isIntersecting) {
            animate(e.target);
            io.unobserve(e.target);
          }
        }
      },
      { threshold: 0.25 }
    );

    nodes.forEach((n) => io.observe(n));
  } else {
    nodes.forEach((n) => runIfNeeded(n));
    window.addEventListener('scroll', () => nodes.forEach((n) => runIfNeeded(n)), { passive: true });
  }
})();

